import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{staticClass:"guest_entry_btn",attrs:{"fixed":"","bottom":"","right":"","ripple":"","dark":"","large":"","fab":"","color":"blue darken-2"},on:{"click":function($event){return _vm.toLogin()}}},[_c(VIcon,{attrs:{"large":""}},[_vm._v("mdi-login-variant")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }